module.exports = __webpack_public_path__ + "img/GH.8ffb8f2d.svg";